import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import Button from "components/CustomButton/CustomButton.jsx";
import CustomPagination from "views/Components/CustomPagination/CustomPagination.jsx";
import SearchBar from "views/Components/SearchBar.jsx";
import { FormGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useBriefings } from "../hooks/useBriefings";
import { useNotifications } from "../hooks/useNotifications";
import Card from "../../../components/Card/Card";
import BriefingsList from "./BriefingsList";
import NotificationSystem from "../components/NotificationSystem";
import LoadingSpinner from "views/Components/LoadingSpinner";
import "./BriefingItem/BriefingItemStyles.scss";

const Briefings = ({ history }) => {
  const { error, success, list, searchQuery, loading, page, totalPages } =
    useSelector((state) => state.briefings);
  const {
    hasAdmin,
    handleDeleteBriefing,
    handleSearchChange,
    handleClearSearch,
    handleNextPage,
    handlePrevPage,
    handleLastPage,
    handleFirstPage,
    fetchBriefings,
    initializeBriefingsPage,
    clearSearchTimeout,
  } = useBriefings();
  const notificationSystem = useNotifications(success, error);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    initializeBriefingsPage();
    clearSearchTimeout();
  }, []);

  const renderDeleteConfirm = (briefingName, id) => {
    setAlert(
      <SweetAlert
        showCancel
        style={{ display: "block", marginTop: "-100px" }}
        title="Confirm Deletion"
        onConfirm={() => {
          handleDeleteBriefing(id);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="danger"
      >
        {`Are you sure you want to delete briefing "${briefingName}"?`}
      </SweetAlert>
    );
  };

  return (
    <div className="main-content">
      <NotificationSystem ref={notificationSystem} />
      {alert}
      <div className="briefing-room-sticky-header">
        <div className="confidentiality-banner">
          <strong>CONFIDENTIALITY NOTICE</strong>
          <p>
            CopLine calls are confidential. Confidentiality will be breached for
            suspected child or elder abuse or endangerment, or a credible threat
            of homicide.
          </p>
        </div>
        <SearchBar
          value={searchQuery}
          onChange={handleSearchChange}
          onSearch={fetchBriefings}
          onClear={handleClearSearch}
          placeholder="Search by content..."
        />
      </div>
      <Card
        content={
          <FormGroup>
            {hasAdmin && (
              <div style={{ marginBottom: 20 }}>
                <Link to={`/admin/create-briefing`}>
                  <Button round fill>
                    Create New Briefing
                  </Button>
                </Link>
              </div>
            )}
            <CustomPagination
              page={page}
              totalPages={totalPages}
              handleNextPage={handleNextPage}
              handlePrevPage={handlePrevPage}
              handleLastPage={handleLastPage}
              handleFirstPage={handleFirstPage}
            />

            {loading.source ? (
              <LoadingSpinner />
            ) : (
              <BriefingsList
                list={list}
                hasAdmin={hasAdmin}
                renderDeleteConfirm={renderDeleteConfirm}
              />
            )}
          </FormGroup>
        }
      />
    </div>
  );
};

export default Briefings;
